import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getItems } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { Props } from './DeviationFormPopup';
import { getScheduleTimestamp } from '../../redux/selectors';

export type StateProps = Pick<Props, 'redirectOnSubmit' | 'scheduleTimestamp'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (
  state,
  { params: { deviationId, isDraft } }
) => {
  // On submit, redirect to deviation unless we're editing a draft and there's other drafts in studio
  const hasOtherDrafts =
    getItems(state, 'STUDIO_DEVIATIONS_STREAM').filter(
      deviation => deviation.deviationId !== deviationId
    ).length > 0;
  return {
    redirectOnSubmit: !isDraft || !hasOtherDrafts,
    scheduleTimestamp: getScheduleTimestamp(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
